import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const BillingIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2.49961 7.74988H17.4996M5.49962 11.2499H7.99962M4 4.25H15.9997C17.1042 4.25 17.9996 5.14473 17.9997 6.24927L17.9999 13.7508C17.9999 14.8554 17.1045 15.75 15.9999 15.75L4.0002 15.7499C2.89566 15.7498 2.00025 14.8545 2.00021 13.7499L2 6.25006C1.99997 5.14546 2.89541 4.25 4 4.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

BillingIcon.displayName = 'BillingIcon';
